import { render, staticRenderFns } from "./PreviewResults.vue?vue&type=template&id=54487d03&scoped=true&"
import script from "./PreviewResults.vue?vue&type=script&lang=js&"
export * from "./PreviewResults.vue?vue&type=script&lang=js&"
import style0 from "./PreviewResults.vue?vue&type=style&index=0&id=54487d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54487d03",
  null
  
)

export default component.exports